<template>
  <p v-if="message" class="low-stock-message" data-testid="low-stock-message">
    <span class="text">{{ message }}</span>
  </p>
</template>

<script>
import { businessLogic } from "@/config.js";
import { mapGetters, mapState } from "vuex";

export default {
  name: "LowStockMessage",
  computed: {
    ...mapState("product", ["selectedVariant"]),
    ...mapGetters("product", [
      "availableForPreOrder",
      "availableForPrebuy",
      "isPreLaunch",
    ]),
    message() {
      if (
        this.isPreLaunch ||
        this.availableForPreOrder ||
        !this.selectedVariant?.availableForSale
      ) {
        return null;
      }

      const quantity = this.selectedVariant.quantityAvailable;

      if (quantity == null || quantity <= 0) {
        return null;
      }

      const threshold = businessLogic.lowStockQuantity;

      if (quantity > threshold) {
        return null;
      }

      return quantity === 1 ? "Last 1 remaining" : "Last few remaining";
    },
  },
};
</script>

<style lang="scss" scoped>
.low-stock-message {
  margin: -12px 0 16px;

  @include respond-above(mg) {
    margin: -28px 0 24px;
  }

  .text {
    @include editorial-body(14px);
    font-style: italic;
    color: $color-black;
    white-space: nowrap;
  }
}
</style>
